namespace TabAurous.Purchase {
    export interface PurchaseTaxRow {
        TransTaxId?: number;
        TransId?: number;
        HSN?: string;
        ProductTypeId?: number;
        NetAmount?: number;
        TaxId?: number;
        TaxRate?: number;
        TaxAmount?: number;
        CessId?: number;
        CessRate?: number;
        CessAmount?: number;
        CCTaxAmount?: number;
        TaxType?: string;
        TaxName?: string;
        LedgerId?: number;
        OutputLedgerId?: number;
        InputRCMLedgerId?: number;
        OutputRCMLedgerId?: number;
        TaxLedgerId?: number;
        CessLedgerId?: number;
        VoucherNo?: string;
        LedgerName?: string;
        PartyTax?: string;
        ECommGST?: string;
        TransDate?: string;
        GrossAmount?: number;
        State?: string;
        ReverseCharge?: string;
        InvoiceType?: string;
        IntegratedTaxAmount?: number;
        CentralTaxAmount?: number;
        StateTaxAmount?: number;
        EligibilityForITC?: string;
    }

    export namespace PurchaseTaxRow {
        export const idProperty = 'TransTaxId';
        export const nameProperty = 'HSN';
        export const localTextPrefix = 'Purchase.PurchaseTax';
        export const deletePermission = 'Purchase:Invoice:Delete';
        export const insertPermission = 'Purchase:Invoice:Add';
        export const readPermission = '*';
        export const updatePermission = 'Purchase:Invoice:Edit';

        export declare const enum Fields {
            TransTaxId = "TransTaxId",
            TransId = "TransId",
            HSN = "HSN",
            ProductTypeId = "ProductTypeId",
            NetAmount = "NetAmount",
            TaxId = "TaxId",
            TaxRate = "TaxRate",
            TaxAmount = "TaxAmount",
            CessId = "CessId",
            CessRate = "CessRate",
            CessAmount = "CessAmount",
            CCTaxAmount = "CCTaxAmount",
            TaxType = "TaxType",
            TaxName = "TaxName",
            LedgerId = "LedgerId",
            OutputLedgerId = "OutputLedgerId",
            InputRCMLedgerId = "InputRCMLedgerId",
            OutputRCMLedgerId = "OutputRCMLedgerId",
            TaxLedgerId = "TaxLedgerId",
            CessLedgerId = "CessLedgerId",
            VoucherNo = "VoucherNo",
            LedgerName = "LedgerName",
            PartyTax = "PartyTax",
            ECommGST = "ECommGST",
            TransDate = "TransDate",
            GrossAmount = "GrossAmount",
            State = "State",
            ReverseCharge = "ReverseCharge",
            InvoiceType = "InvoiceType",
            IntegratedTaxAmount = "IntegratedTaxAmount",
            CentralTaxAmount = "CentralTaxAmount",
            StateTaxAmount = "StateTaxAmount",
            EligibilityForITC = "EligibilityForITC"
        }
    }
}
